import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Accordion,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomNavbar from "../../../components/CustomNavbar";
import messages from "../../../redux/messages";
import { getCompetenciesDesc } from "../../../redux/descriptorsProfiles/competenciesDesc/actions";
import { getCompetenciesType } from "../../../redux/descriptorsProfiles/CompetenciesType/actions";
import { getMenuItemId } from "react-bootstrap-typeahead/types/utils";
import CompetenceLevel from "../../../components/descriptorsProfiles/CompetenceLevel";
import { getGeneralInfoById } from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import { getTotalCompetence } from "../../../redux/descriptorsProfiles/TotalCompetence/actions";

const CompetenciesLevel = (props) => {
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();

  // const {
  //   loading,
  //   loadingById,
  //   saveLoading,
  //   saveLoadingById,
  //   assignCompetenciesLength,
  //   assignCompetencies,
  //   assignCompetencie,
  //   assignCompetenciesError,
  //   formError,
  // } = useSelector((store) => store.assignCompetencies);

  const { loaderCompetencies, competencies, competenciesFaild } = useSelector(
    (store) => store.competencies
  );

  const { generalInfo, loadingById, generalInfoError } = useSelector(
    (store) => store.generalInfo
  );

  const { competenciesTypes, competenciesTypesLength, competenciesTypeError } =
    useSelector((store) => store.competenciesType);

  const loaderCompetenciesTypes = useSelector(
    (store) => store.competenciesType.loading
  );

  const {
    loading,
    competenciesTotalsLength,
    competenciesTotals,
    competenciesTotalError,
  } = useSelector((store) => store.competenciesTotal);

  // const changeNumber = (id, number) => {
  //   elements = { id: id, value: number };
  //   setValue(elements);
  // };

  let elements = [];

  if (competenciesTypes && competenciesTypes) {
    competenciesTypes.map((item, id) => {
      elements = [...elements, { id: id, value: 1 }];
    });
  }

  useEffect(() => {
    dispatch(getCompetenciesType({}));
    dispatch(getGeneralInfoById(parseInt(props.match.params.id)));
    dispatch(getTotalCompetence({},2, setValue));
  }, []);

  return (
    <>
      <Container>
        {loading ? (
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        ) : (
          competenciesTotalsLength > 0 && (
            <>
              <Col className="my-4">
                <div className="my-4 mx-4 border-left border-warning">
                  <Alert variant="light">
                    <p>
                      Señale las competencias que la persona que ocupe este
                      puesto debe poseer para la consecucion de las actividades
                      esenciales. Para aquellas competencias requeridas, indique
                      el nivel de desarrollo que debe tener, este nivel de
                      desarrollo debe de ir de 1 a 5. Recuerde que no es
                      necesario marcar todas las competencias, seleccione las{" "}
                      {competenciesTotals[0].total} más importantes (guiarse del
                      manual de competencias).
                    </p>
                  </Alert>
                </div>
                {loaderCompetenciesTypes || loadingById ? (
                  <>
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {competenciesTypesLength !== 0 &&
                      generalInfo.clasificacion_empleado &&
                      generalInfo.list_division &&
                      competenciesTypes.map((item, index) => (
                        <div key={item.id} className="my-3">
                          <Accordion>
                            <Card>
                              <Accordion.Toggle
                                as={Card.Header}
                                eventKey={toString(index)}
                                className="bg-acordion-descriptores d-flex flex-wrap justify-content-between align-items-center"
                              >
                                {item.descripcion}
                                <i className="material-icons">add_circle</i>
                              </Accordion.Toggle>
                              <Accordion.Collapse eventKey={toString(index)}>
                                <Card.Body>
                                  <Container>
                                    <CompetenceLevel
                                      competenceType={item}
                                      index={index}
                                      descriptor={generalInfo}
                                      idDescriptor={parseInt(
                                        props.match.params.id
                                      )}
                                      total={value}
                                      setTotal={setValue}
                                    />
                                  </Container>
                                </Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          </Accordion>
                        </div>
                      ))}
                  </>
                )}
                {(!loaderCompetenciesTypes &&
                  competenciesTypesLength === 0 &&
                  competenciesTypeError === "") ||  (!loadingById && !generalInfo.clasificacion_empleado) ? (
                    <Alert variant="info" className="my-4">
                      Aún no hay tipos de competencia, comuniquese con el
                      administrador para mas información.
                    </Alert>
                  ): null}
                {generalInfo.clasificacion_empleado === null &&
                  generalInfo.division === null && (
                    <Alert variant="info" className="my-4">
                      Debe asignar una clasificación y una división a este
                      descriptor.
                    </Alert>
                  )}
                {!!competenciesTypeError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {competenciesTypeError}
                  </Alert>
                )}
                {!!generalInfoError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {generalInfoError}
                  </Alert>
                )}
              </Col>
            </>
          )
        )}
        {!!competenciesTotalError && (
          <Alert variant="danger" className="mt-4 mb-1 mx-3">
            {competenciesTotalError}
          </Alert>
        )}
      </Container>
    </>
  );
};

export default CompetenciesLevel;
